import {Component, EventEmitter, OnInit} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Column, GridOption, AngularGridInstance, Formatters, Formatter} from 'angular-slickgrid';


@Component({
    selector: 'app-asset-report',
    templateUrl: './asset-report.component.html',
    styleUrls: ['./asset-report.component.css']
})


export class AssetReportComponent implements OnInit {
    masterNameObj = [];
    masterNameSelected: number;
    private notifier: NotifierService;
    respObject: any;
    clientId: number;
    formData: any;
    assetReportDownloadUrl: String;
    assetValue: string;
    isDisabledBtn: boolean;

    columnDefinitions: Column[];
    gridOptions: GridOption;
    dataset = [];
    angularGrid: AngularGridInstance;
    gridObj: any;
    gridWidth: number;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                notifier: NotifierService) {
        this.notifier = notifier;
    }

    ngOnInit() {
        this.assetReportDownloadUrl = this._rest.slaRoot + '/downloadAssetReport';
        this.assetValue = '';
        this.isDisabledBtn = false;

        const downloadLinkFormatter: Formatter = (row: number, cell: number, value: any, columnDef: Column, dataContext: any, grid?: any) =>
            value ? `<a mat-raised-button target="blank" href=${value}>Download</a>` : '';

        const columnDefinitions = [

            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'reporttype', name: 'Report Type', field: 'reporttype', sortable: true, filterable: true
            },
            {
                id: 'createdate', name: 'Create Date', field: 'createdate', sortable: true, filterable: true
            },
            {
                id: 'download', name: 'Download', field: 'download', sortable: false, filterable: false, formatter: downloadLinkFormatter
            }
        ];

        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: false,
            enableRowSelection: true,
        };

        this.columnDefinitions = columnDefinitions;

        this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.clientId = this.respObject.details[0].clientId;
                this.formData = {
                    'clientId': this.clientId,
                    'createdBy': this.messageService.getUserId()
                };
                // ======================================= get asset master data =============================================
                this.getAssetMasterData();

                // ================================================================================

                this.getAssetReportTableData();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });


    }

    getAssetReportTableData() {
        this._rest.getAssetReportDataTable(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            console.log(this.respObject);
            if (this.respObject.success) {
                console.log(this.respObject);
                const tableDataArray = this.respObject.details;
                for (let j = 0; j < tableDataArray.length; j++) {
                    const fileName = tableDataArray[j].filename;
                    tableDataArray[j].download = this.messageService.ASSET_REPORT_PATH + fileName;
                }
                this.dataset = tableDataArray;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getAssetMasterData() {
        this._rest.getAssetManagementMaster(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                const dataArr = this.respObject.details;
                // console.log('master data=', dataArr);
                this.masterNameObj = dataArr;
                this.masterNameObj.unshift({id: 0, masterName: 'All'});
                this.masterNameSelected = 0;
                // this.totalData = dataArr.length;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
        const classes = document.getElementsByClassName('search-filter');
        for (let i = 0; i < classes.length; i++) {
            classes[i].setAttribute('placeholder', '');
        }
        this.gridObj.onBeforeEditCell.subscribe((e, args) => {
            // this.messageService.setBeforeChangeData(args);

            if (args.item.seq !== 1 && args.item.type === 'ClientTicket') {
                // console.log('invalid');
                return false;
            }
        });
    }

    downloadAllAssetReport() {
        // document.location.href = this.assetReportUrl + '?description=' +
        // '&masterid=' + this.masterNameSelected + '&clientId='+this.clientId;
        this.isDisabledBtn = true;
        this._rest.getAssetManagementReport('', this.masterNameSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                console.log(res1);
                this.notifier.notify('success', this.messageService.REPORT_SUCCESS);
                this.isDisabledBtn = false;
                this.getAssetReportTableData();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
                this.isDisabledBtn = false;
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
            this.isDisabledBtn = false;
        });
    }


    downloadAssetReportByDescriptionId() {
        this.isDisabledBtn = true;
        if (this.assetValue === '') {
            this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
            this.isDisabledBtn = false;
        } else {
            this._rest.getAssetManagementReport(this.assetValue, 0, this.clientId).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    console.log(res1);
                    this.notifier.notify('success', this.messageService.REPORT_SUCCESS);
                    this.isDisabledBtn = false;
                    this.getAssetReportTableData();
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                    this.isDisabledBtn = false;
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                this.isDisabledBtn = false;
            });
        }
    }

}
